export enum ReportOfferReason {
  NotTutoringOffer = 1,
  NotAvailable = 2,
  MultipleAccounts = 3,
  Offensive = 4,
}
